<template>
  <header class="header">
    <h2 class="box__title text--ellipsis">
      <span class="text--regular">Top 5</span>&nbsp;
      <span class="text--lowercase">{{ $t(`Common.${type}`) | textLowercase }}</span>
    </h2>

    <router-link
      v-if="status === 'success'"
      :to="route"
      :title="$t('Common.seeMore')"
      class="action"
    >
      <span>{{ $t('Common.seeMore') }}</span>
      <v-icon color="primary" small>add</v-icon>
    </router-link>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    type: {
      type: String
    },
    route: {
      type: Object
    },
    status: {
      type: String,
      default: 'loading'
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  margin-bottom: 8px;
  position: relative;
}

.box__title {
  padding-right: 80px;
}

a.action {
  align-items: center;
  display: flex;
  font-size: $base-font-size - 1px;
  line-height: 1;
  position: absolute;
  right: 0;
  text-decoration: none;
  top: 50%;
  transform: translateY(-50%);

  &:hover {

    span {
      text-decoration: underline;
    }
  }
}
</style>
